import { bubEvents } from 'shared/events/bub_events';

$(document).ready(() => {
  $('.focus-light-content .logo-only-header').on('click touch', () => {
    bubEvents.track('Header', 'Clicked link', { label: 'Chirp logo' });
  });
});
